// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import localizer from 'share/localization/Izenda.Localizer';
import { forEach } from 'lodash/fp';

const SAVE_KEY = 0;
const COPY_KEY = 1;
const MOVE_KEY = 2;

const REQUIRED_FILTER = 'RequiredFilters';
const LEFT_MENU_CONCAT_TREE_MAP = [
  {
    prop: 'subCategories',
    expand: false,
    children: [
      {
        prop: 'subCategories',
        expand: false
      }
    ]
  }
];

export default {
  DASHBOARD_PART_MIN_WIDTH: 5,

  get GLOBAL_DASHBOARD() {
    return localizer.getText('COMMON_LABEL_GLOBAL_DASHBOARD');
  },
  get UNCATEGORIZED() {
    return localizer.getText('COMMON_LABEL_UNCATEGORIZED');
  },
  get DASHBOARD_DEFAULT_NAME() {
    return localizer.getText('DASHBOARD_DEFAULT_NAME');
  },
  TITLE_MAX_LENGTH: 256,
  get ALL_CATEGORY_TYPES() {
    return {
      ALL_DASHBOARDS: {
        name: localizer.getText('DASHBOARD_LABEL_ALL_DASHBOARD'),
        type: 0,
        id: '0000',
        isGlobal: null
      }
    };
  },
  EMPTY_GUID: '00000000-0000-0000-0000-000000000000',
  get CONSTRAINTS() {
    return {
      NAME: {
        presence: {
          presence: true,
          message: localizer.getText('DASHBOARD_CONSTRAINTS_REQUIRED_NAME')
        }
      }
    };
  },
  get TOOLBAR_CONTROL() {
    return [
      { label: localizer.getText('DASHBOARD_LABEL_PRESENTATION'), value: 0 },
      { label: localizer.getText('DASHBOARD_LABEL_ACCESS'), value: 1 },
      { label: localizer.getText('COMMON_LABEL_SUBSCRIBE'), value: 2 },
      { label: localizer.getText('COMMON_LABEL_SCHEDULE'), value: 3 },
      { label: localizer.getText('COMMON_LABEL_SAVE'), value: 4 }
    ];
  },
  get TILE_TYPE() {
    return {
      reportPart: {
        type: 'reportPart',
        label: localizer.getText('COMMON_LABEL_REPORT_PART'),
        icon: 'icon-report-format',
        needPopup: true
      },
      text: {
        type: 'text',
        label: localizer.getText('COMMON_LABEL_TEXT'),
        icon: 'icon-text-format',
        needPopup: false
      }
    };
  },
  get SEARCH_CRITERIA() {
    return [
      { value: 'All', label: localizer.getText('COMMON_LABEL_ALL') },
      { value: 'DashboardName', label: localizer.getText('DASHBOARD_LABEL_NAME') },
      { value: 'DashboardDescription', label: localizer.getText('DASHBOARD_LABEL_DASHBOARD_DESCRIPTION') },
      { value: 'CreatedBy', label: localizer.getText('COMMON_CRITERIA_CREATED_BY') },
      { value: 'CreatedDate', label: localizer.getText('COMMON_CRITERIA_CREATED_DATE') },
      { value: 'LastEditedBy', label: localizer.getText('COMMON_CRITERIA_EDITED_BY') },
      { value: 'LastEditedDate', label: localizer.getText('COMMON_CRITERIA_EDITED_DATE') },
      { value: 'Category', label: localizer.getText('COMMON_LABEL_CATEGORY') },
      { value: 'Subcategory', label: localizer.getText('COMMON_LABEL_SUBCATEGORY') },
      { value: 'LastViewed', label: localizer.getText('COMMON_CRITERIA_LAST_VIEWED') }
    ];
  },
  get SORT_CRITERIA() {
    return [
      { value: 'DashboardName', label: localizer.getText('DASHBOARD_LABEL_NAME') },
      { value: 'CreatedBy', label: localizer.getText('COMMON_CRITERIA_CREATED_BY') },
      { value: 'CreatedDate', label: localizer.getText('COMMON_CRITERIA_CREATED_DATE') },
      { value: 'LastEditedBy', label: localizer.getText('COMMON_CRITERIA_EDITED_BY') },
      { value: 'LastEditedDate', label: localizer.getText('COMMON_CRITERIA_EDITED_DATE') },
      { value: 'NumberOfView', label: localizer.getText('COMMON_CRITERIA_NUMBER_OF_VIEWS') },
      { value: 'RenderingTime', label: localizer.getText('COMMON_CRITERIA_AVERAGE_RENDERING_TIME') },
      { value: 'Category', label: localizer.getText('COMMON_LABEL_CATEGORY') },
      { value: 'Subcategory', label: localizer.getText('COMMON_LABEL_SUBCATEGORY') }
    ];
  },
  SORT_TYPES: {
    ASC: 'asc',
    DESC: 'desc'
  },
  CATEGORY_TYPE: {
    CATEGORY_ID: 'CategoryId',
    SUB_CATEGORY_ID: 'SubCategoryId'
  },
  STICKY: {
    top: 165,
    topOffset: -204,
    bottomOffset: 0
  },
  DATETIME_FORMAT: 'MM/dd/yyyy',
  get MESSAGE() {
    return {
      M01: localizer.getText('DASHBOARD_MESSAGE_CONFIRM_DELETE'),
      M06a: localizer.getText('DASHBOARD_MESSAGE_MOVE_SUCCESSFULLY'),
      M06b: localizer.getText('DASHBOARD_MESSAGE_COPY_SUCCESSFULLY'),
      M07: localizer.getText('DASHBOARD_MESSAGE_SPECIFY_DESTINATION'),
      INVALID_IMAGE_URL: localizer.getText('DASHBOARD_MESSAGE_INVALID_IMAGE_URL')
    };
  },
  get TILE_LABEL_TEXT() {
    return {
      contentTitle: localizer.getText('COMMON_LABEL_TITLE'),
      contentDescription: localizer.getText('COMMON_LABEL_DESCRIPTION'),
      body: localizer.getText('DASHBOARD_LABEL_BODY_TEXT')
    };
  },
  get SAVE_POPUP_CONFIG() {
    return {
      DASHBOARD_NAME: localizer.getText('DASHBOARD_LABEL_NAME'),
      CATEGORY: localizer.getText('COMMON_LABEL_CATEGORY'),
      SUBCATEGORY: localizer.getText('COMMON_LABEL_SUBCATEGORY'),
      SAVEINTO: localizer.getText('COMMON_LABEL_SAVEINTO')
    };
  },
  get ACTION_ENUM() {
    return {
      0: localizer.getText('COMMON_LABEL_SAVE'),
      1: localizer.getText('COMMON_LABEL_COPY'),
      2: localizer.getText('COMMON_LABEL_MOVE')
    };
  },
  get SELECT_CATEGORY_HINT() {
    return localizer.getText('REPORTDESIGNER_MESSAGE_HINT_CATEGORY');
  },
  get SELECT_SUB_CATEGORY_HINT() {
    return localizer.getText('REPORTDESIGNER_MESSAGE_HINT_SUB_CATEGORY');
  },
  SAVE_KEY,
  COPY_KEY,
  MOVE_KEY,
  get DASHBOARD() {
    return localizer.getText('COMMON_LABEL_DASHBOARD');
  },
  get DESCRIPTION() {
    return {
      DESCRIPTION_LABEL: localizer.getText('DASHBOARD_MESSAGE_MISSING_DESCRIPTION'),
      TITLE: localizer.getText('DASHBOARD_LABEL_DASHBOARD_DESCRIPTION')
    };
  },
  get BACKGROUND_IMAGE() {
    return {
      IMAGE_URL_LABEL: localizer.getText('DASHBOARD_LABEL_IMAGE_URL'),
      STRETCH_IMAGE_LABEL: localizer.getText('DASHBOARD_LABEL_STRETCH_IMAGE'),
      TITLE: localizer.getText('DASHBOARD_LABEL_BACKGROUND_IMAGE')
    };
  },
  validateFilterMessage(result) {
    let validateMessage = '';

    const messages = result.messages;
    // Messages level : Just 1 message required for now
    if (messages.length > 0 && messages[0].messages[0]) {
      validateMessage += `<p>${messages[0].messages[0]}</p>`;
    } else {
      return '';
    }

    validateMessage += '<ul style="list-style-type: decimal" >';

    result.messages[0].detail.forEach(detail => {
      let reportParts = '';
      const COMMON_FILTER_FIELD = {
        KEY: 'CommonFilterFields',
        NAME: localizer.getText('DASHBOARD_COMMON_FILTER_FIELDS')
      };

      // Report parts level
      const reportPartName = detail.key === COMMON_FILTER_FIELD.KEY ? COMMON_FILTER_FIELD.NAME : detail.key;

      reportParts = `<li>${reportPartName}`;
      reportParts += '<ul style="list-style-type: decimal" >';
      // Filters Level
      forEach(value => {
        reportParts += `<li>${value}</li>`;
      }, detail.value);

      reportParts += '</ul></li>';

      validateMessage += reportParts;
    });

    validateMessage += '</ul>';

    return validateMessage;
  },
  DASHBOARD_LIST_CONCAT_TREE_MAP: [
    {
      prop: 'subCategories',
      children: [
        {
          prop: 'subCategories',
          children: [
            {
              prop: 'dashboards'
            }
          ]
        }
      ]
    }
  ],
  LEFT_MENU_CONCAT_TREE_MAP,
  LEFT_MENU_TREE_MAP: [
    {
      prop: 'globalLocalCategory',
      expand: true,
      children: LEFT_MENU_CONCAT_TREE_MAP
    }
  ],
  DASHBOARD_PART_WORKER_CHUNK: 3
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.DashboardConstants.js